import { api } from './api';

const list = (proposal_id) => {
  return api({method: 'GET', url: process.env.REACT_APP_API_URL+'/'+proposal_id+'/mpr'});
}

const mprSave = (input) => {
  return api({method: 'POST', url: process.env.REACT_APP_API_URL+'/mpr'}, input);
}

const mprDelete = (mpr_id) => {
  return api({method: 'DELETE', url: process.env.REACT_APP_API_URL+'/mpr/'+mpr_id});
}

const te = (mpr_id) => {
  return api({method: 'GET', url: process.env.REACT_APP_API_URL+'/mpr/'+mpr_id+'/te'});
}


export const mprService = {
  list,
  mprSave,
  mprDelete,
  te,
};